import {ChangeEvent, KeyboardEvent, ClipboardEvent, FC, useRef, Dispatch, SetStateAction} from 'react';
import {twoStepAuthenticationStyles} from '../TwoStepAuthentication.styles';
import {Box} from '@mui/material';

interface CodeFormProps {
	code: string[];
	handleCode: Dispatch<SetStateAction<string[]>>;
}

export const CodeForm: FC<CodeFormProps> = ({code, handleCode}) => {
	const inputRefs = useRef<HTMLInputElement[]>([]);

	const handleChange = (index: number, event: ChangeEvent<HTMLInputElement>) => {
		const newValues = [...code];
		newValues[index] = event.target.value;

		if (event.target.value && index < 5) {
			inputRefs.current[index + 1].focus();
		}
		handleCode(newValues);
	};

	const handleKeyDown = (index: number, event: KeyboardEvent<HTMLInputElement>) => {
		if (event.key === 'Backspace' && !code[index] && index > 0) {
			inputRefs.current[index - 1].focus();
		}
	};

	const handlePaste = (event: ClipboardEvent<HTMLInputElement>) => {
		const pastedData = event.clipboardData.getData('text').slice(0, 6);
		if (pastedData.length === 6) {
			handleCode(pastedData.split(''));
			inputRefs.current[5].focus();
		}
	};

	return (
		<Box sx={twoStepAuthenticationStyles.form}>
			{code.map((value, index) => (
				<input
					key={index}
					type="text"
					maxLength={1}
					value={value}
					onChange={(event) => handleChange(index, event)}
					onKeyDown={(event) => handleKeyDown(index, event)}
					onPaste={handlePaste}
					// eslint-disable-next-line no-return-assign
					ref={(el) => (inputRefs.current[index] = el!)}
				/>
			))}
		</Box>
	);
};
